import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import { getRadius } from '../../../foundation/theme/shape.utils';
import tokens from '../../../foundation/tokens/js/tokens';
import { getFontSize, getFontWeight } from '../../../foundation/theme/typography.utils';
import { getSchemaVariant } from '../../../foundation/theme/palette.utils';
// styled-components.
// -----------------------------------------------------------------------------
export const ControlledActionSpin = styled.div `
  // Display & Box.
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1px 0;
  width: 100%;
`;
export const ControlledActionLinkSpin = styled.div `
  // Display & Box.
  align-items: center;
  display: flex;
  gap: ${getSpace('m')};
  padding: ${getSpace('xl')};

  // Other.
  cursor: pointer;

  &:hover {
    background-color: ${tokens.colors.active[100].value};
    color: ${tokens.colors.navy[800].value};
  }
`;
export const ControlledActionButton = styled.button `
  ${({ isOpen }) => {
    return css `
      // Box model.
      border: none;

      // Colors.
      background-color: ${isOpen
        ? tokens.colors.active[100].value
        : 'transparent'};

      ${isOpen &&
        `
        color: ${tokens.colors.navy[800].value};
      `}

      // Space.
      padding: ${getSpace('l')};

      // Miscellanea.
      cursor: pointer;

      svg {
        height: 20px;
        width: 20px;
      }

      ${!isOpen &&
        `
        &:hover {
        svg {
          opacity: 0.3;
        }
      }
      `}
    `;
}}
`;
export const ControlledActionGroup = styled.div `
  // Display & Box model.
  padding-bottom: ${getSpace('s')};
  padding-left: ${getSpace('xl')};
  padding-right: ${getSpace('xl')};
  padding-top: ${getSpace('s')};

  // Color.
  color: ${tokens.colors.midnight[500].value};

  // Text.
  font-size: ${getFontSize('xs')};
  font-weight: ${getFontWeight('black')};
  text-transform: uppercase;
`;
export const ControlledActionSeparator = styled.div `
  // Display & Box model.
  background: ${tokens.colors.midnight[200].value};
  height: 2px;
  margin-bottom: ${getSpace('xs')};
  margin-top: ${getSpace('xs')};
  width: 100%;
`;
export const ControlledActionsOptionsWrapper = styled.div `
  ${({ theme }) => {
    return css `
      // Box model.
      border-radius: ${getRadius(theme, 'm')};
      display: flex;
      flex-direction: column;
      position: absolute;
      right: 0;
      top: 60px;
      white-space: nowrap;
      width: fit-content;

      z-index: 10;

      // Space.
      padding: ${getSpace('s')};

      // Color.
      background-color: ${tokens.colors.white[100].value};
      border: 2px solid ${tokens.colors.midnight[200].value};
    `;
}}
`;
export const ControlledActionWrapper = styled.div `
  // Box model.
  display: flex;
  flex-direction: column;
  gap: ${getSpace('2xs')};
  min-width: 56px;
  position: relative;
`;
export const ControlledActionOptionAsButton = styled.button `
  ${({ schema, theme }) => {
    const { default: color } = getSchemaVariant({
        mode: 'light',
        schema,
        theme,
        variant: 'bare'
    });
    return css `
      // Box model.
      align-items: center;
      border: none;
      display: flex;

      // Colors.
      background-color: ${color.background};
      color: ${color.foreground};

      svg {
        color: ${color.foregroundAlt};
      }

      // Space.
      cursor: pointer;
      gap: ${getSpace('m')};
      padding: ${getSpace('xl')};

      &:hover {
        background-color: ${tokens.colors.active[100].value};
      }

      > span {
        display: inline-block;
      }
    `;
}}
`;
export const ControlledActionOptionAsLink = styled.a `
  // Display & Box model.
  align-items: center;
  border: none;
  display: flex;
  gap: ${getSpace('m')};
  padding: ${getSpace('xl')};

  // Colors.
  background-color: transparent;
  color: inherit;

  // Other.
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: ${tokens.colors.active[100].value};
    color: ${tokens.colors.navy[800].value};
  }

  &:visited,
  &:active,
  &:focus {
    color: inherit;
  }

  > span {
    display: inline-block;
  }
`;
export const ControlledActionsRoot = styled.td `
  ${({ borderType }) => {
    return css `
      ${borderType === 'full' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'row' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'column' &&
        `
      box-shadow: -3px 0px 0px 0px rgba(38, 26, 25, 0.05);
      `}
    `;
}}
`;
//# sourceMappingURL=ControlledActions.styled.js.map